import { api } from './client';
import { MetaViewDto, PagedResponseMetaViewDto, UpsertMetaDto } from './types';

export interface MetaListQuery {
  query?: string;
  locale?: string;
  page?: number;
  limit?: number;
}

export const listMeta = async (query: MetaListQuery): Promise<PagedResponseMetaViewDto> => {
  const { data } = await api.get<PagedResponseMetaViewDto>('/admin/meta', { params: query });
  return data;
};

export const getMetaByTags = async (tags: string, locale?: string): Promise<MetaViewDto> => {
  const { data } = await api.get<MetaViewDto>('/admin/meta/by-tags', { params: { tags, locale } });
  return data;
};

export const upsertMetaByTags = async (tags: string, payload: UpsertMetaDto, locale?: string): Promise<MetaViewDto> => {
  const { data } = await api.put<MetaViewDto>('/admin/meta/by-tags', payload, { params: { tags, locale } });
  return data;
};

export const deleteMetaByTags = async (tags: string, locale?: string): Promise<void> => {
  await api.delete('/admin/meta/by-tags', { params: { tags, locale } });
};
